import React, { Component, Fragment } from 'react';
import Routes from '../../routes';
import { Cadena_Listkey, Menu_Por_Usuario } from '../../request/rfc';
import  { Button } from './children/button';
import Wrapper from './children/wrapper';

export default class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            descripcion : '',
            buttonHomeExterno: [],
            buttonHomeInterno: [],
            labelCadena_Leyenda_Contribuyente: ''
        };

        console.log('entrando a home')
    }

    componentDidMount() {
        const { baseUrl } = this.state;
        const { isSiteInterno } = this.props;
        Cadena_Listkey()
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message === '') {
                const descripcion = Data.Leyenda_Web;
                const Cadena_Leyenda_Contribuyente = Data.Leyenda_Web;
                if(isSiteInterno == '0') {
                    this.setState({ descripcion, buttonHomeExterno: [ 
                                        { col: 'col-sm-6', to: `${baseUrl}${Routes.RFC}`, icon: 'fas fa-ticket-alt', label: 'Factura' },
                                        { col: 'col-sm-6', to: `${baseUrl}${Routes.Consulta}`, icon: 'fas fa-search', label: 'Consulta' }
                                    ]
                    });
                } else {
                    Menu_Por_Usuario()
                    .then(({ data: Response }) => {
                        const { Message, Data } = Response;
                        if(Message !== '') {
                            alert(Message);
                        } else {
                            const buttonHomeInterno = Data.map(item => Object.assign({}, item, {
                                col: 'col-sm-6 mb-5', to: item.Url, icon: item.Imagen, label: item.Nombre
                            }));
                            this.setState({ descripcion, buttonHomeInterno });
                        }
                    })
                    .catch((err) => { console.log(err); });
                }
                this.setState({ Cadena_Leyenda_Contribuyente });
            } else {
                alert(Message);
            }
        })
        .catch((err) => { console.log(err); });
    }

    render() {
        const { descripcion, buttonHomeExterno, buttonHomeInterno, Cadena_Leyenda_Contribuyente } = this.state;
        const { isSiteInterno } = this.props;
        let buttons = [];
        
        if(isSiteInterno == '1') {
            buttons = buttonHomeInterno.map((item, index)=> <Button key={index} 
                                                            col={item.col}
                                                            to={item.to} 
                                                            icon={item.icon}
                                                            label={item.label} />
                                                )
        } else {
            buttons = buttonHomeExterno.map((item, index)=> <Button key={index} 
                                                            col={item.col}
                                                            to={item.to} 
                                                            icon={item.icon}
                                                            label={item.label} />
                                                )
        }
        return (
            <Wrapper descripcion={descripcion}>
                <div className="row">
                    {buttons}
                </div>
                <div className="row" style={{  justifyContent: 'center', alignItems: 'center' }}>
                    <p className="mt-5 mb-3 text-muted" >{Cadena_Leyenda_Contribuyente}</p>
                </div>
            </Wrapper>
            
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/home/index.jsx